export interface TableActionInlineCandidate {
  placement?: 'fixed-inline' | 'inline-priority' | 'menu';
}

export interface ResolveTableActionOverflowInput {
  availableWidth: number;
  menuWidth?: number;
  fixedActionWidths?: number[];
  inlineActionWidths: number[];
  gap?: number;
}

export interface TableActionOverflow {
  visibleInlineCount: number;
}

function requiredWidth(
  menuWidth: number,
  fixedActionWidths: number[],
  inlineActionWidths: number[],
  gap: number
): number {
  const fixedWidth = fixedActionWidths.reduce((sum, width) => sum + width, 0);
  const inlineWidth = inlineActionWidths.reduce((sum, width) => sum + width, 0);
  const itemCount = (menuWidth > 0 ? 1 : 0) + fixedActionWidths.length + inlineActionWidths.length;
  const gapWidth = Math.max(0, itemCount - 1) * gap;
  return menuWidth + fixedWidth + inlineWidth + gapWidth;
}

export function resolveTableActionFixedInlineActions<T extends TableActionInlineCandidate>(
  actions: T[]
): T[] {
  return actions.filter((action) => action.placement === 'fixed-inline');
}

export function resolveTableActionInlineCandidates<T extends TableActionInlineCandidate>(
  actions: T[]
): T[] {
  return actions.filter((action) => action.placement === 'inline-priority');
}

export function resolveTableActionOverflow({
  availableWidth,
  menuWidth = 0,
  fixedActionWidths = [],
  inlineActionWidths,
  gap = 8,
}: ResolveTableActionOverflowInput): TableActionOverflow {
  for (let count = inlineActionWidths.length; count > 0; count -= 1) {
    if (
      requiredWidth(menuWidth, fixedActionWidths, inlineActionWidths.slice(0, count), gap) <=
      availableWidth
    ) {
      return { visibleInlineCount: count };
    }
  }

  return { visibleInlineCount: 0 };
}
